module.exports = __webpack_public_path__ + "img/streamify-logotype-blue.e1185de8.svg";